//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import lazyLoadSelect from "@/components/LazyLoadSelect";
import { date } from "quasar";
import router from "../router";
import logger from "@/utils/logger";
import { getFilteredProducts } from "./../store/main/actions";

export default {
  components: {    
    lazyLoadSelect
  },

  data() {
    return {
      serialNumbers: [],
      allCustomers: [],
      customers: [],
      customerId: null,
      //allProducts: [],
      products: [],
      productId: null,
      filter: "",
      hideTableBottom: true,

      columns: [
        {
          name: "regDate",
          align: "left",
          label: "Dato",
          field: "regDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "serialNumber",
          align: "left",
          label: this.$t("pick.serialNumbers"),
          field: "serialNumber",
          sortable: true,
        },       
        {
          name: "customer",
          align: "left",
          label: this.$t("order.customer"),
          field: "customer",
          sortable: true,
        },
        {
          name: "product",
          align: "left",
          label: this.$t("products.product"),
          field: "product",
          sortable: true,
        },   
        {
          name: "customerOrderNumber",
          align: "left",
          label: this.$t("order.orderNo"),
          field: "customerOrderNumber",
          sortable: true,
        },
        {
          name: "OrderType",
          align: "left",
          label: "Ordretype",
          field: "orderType",
          format: (val) => this.mapOrderType(val),
          sortable: true,
        },
      ],
    };
  },
  
  async mounted() {
    await Promise.allSettled([
      //(this.allCustomers = await this.getCustomers()),
      //(this.allCustomers.unshift({id: -1, name: ""})),
      //(this.customers = this.allCustomers),
      //(this.allProducts = await this.getArticles()),
      //(this.allProducts.unshift({id: -1, productName: ""})),
      //(this.products = this.allProducts),
      this.refresh(),
    ]);

    window.dispatchEvent(new Event("resize"));
  },

  methods: {
    ...mapActions("main", [
        "getSerialNumberByProductOrCustomer", 
        "getCustomers",
        "getArticles",
        "getReferencesProducts",
        "getReferencesCustomer",
    ]),

    mapOrderType(orderType) {
      const orderTypeMap = {
        0: "Salgsordre",
        1: "Returordre",
        2: "Innkjøpsordre",
      };
      return orderTypeMap[orderType] ?? orderType;
    },

    async fetchProducts({ pageNumber, pageSize, searchQuery }) {
            try {
                const result = await this.getReferencesProducts({
                    pageNumber,
                    pageSize,
                    searchQuery,
                    sortBy: 'ProductNumber',
                    sortDescending: false
                })
                return result
            } catch (error) {
                console.error('Error fetching products:', error)
                return { items: [], totalPages: 1 }
            }
        },

      async fetchProduct(productId) {
          try {
              const result = await this.getProduct(productId)
              logger.log({result})
              return result
          } catch (error) {
              console.error('Error fetching product:', error)
              return null;
          }
      },

      async fetchFilteredProducts() {
        try {
          const payload = {
            serialNumber: this.filter,
            productId: this.productId,
            customerId: this.customerId,
            pageNumber: 1,
            pageSize: 50,
            sortBy: 'SerialNumber',
            sortDescending: false,
            includeDeleted: false,
            includeDeactivated: false
          }
          const result = await getFilteredProducts(payload)

          this.serialNumbers = result.items;
        } catch (error) {
          console.error('Error fetching filtered products:', error)
          return null;
        }
      },

      productLabel(product) {
          if (!product) return ''
          return `${product.productNumber}: ${product.productName}`
      },

    async refresh() {
      this.serialNumbers = [];
      this.customerId = null;
      this.productId = null;
      this.filter = "";

      window.dispatchEvent(new Event("resize"));
    },

    filterCustomers(val, update) {
      if (!this.allCustomers) {
        update();
        return;
      }
      update(() => {
        this.customers = this.allCustomers.filter(
          (c) => c.name.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },    
    
    async fetchCustomers({ pageNumber, pageSize, searchQuery }) {
            try {
                const result = await this.getReferencesCustomer({
                    pageNumber,
                    pageSize,
                    searchQuery,
                    sortBy: 'CustomerNumber',
                    sortDescending: false,
                    statusCode: 30001
                })
                return result
            } catch (error) {
                console.error('Error fetching customer:', error)
                return { items: [], totalPages: 1 }
            }
        },

      async fetchCustomer(customerId) {
          try {
              const result = await this.getSalesOrder(customerId)
              logger.log({result})
              return result
          } catch (error) {
              console.error('Error fetching customer:', error)
              return null;
          }
      },

      customerLabel(customer) {
          if (!customer) return ''
          return `${customer.customerNumber} ${customer.name}`
      },
      
    openOrder(row) {
      if (row.orderType == 0) {
        router.push({ name: "Order", params: { id: row.customerOrderId } });
      }
      else if (row.orderType == 1) {
        router.push({ name: "ReturnOrder", params: { id: row.customerOrderId } });
      }
      else if (row.orderType == 2) {
        router.push({ name: "Purchase", params: { id: row.purchaseOrderId } });
      }     
    },
  },
};
